import { defineMessages } from 'react-intl';

export default defineMessages({
  overview: {
    description: 'insights.Overview',
    defaultMessage: 'Overview',
    id: 'ctuATK',
  },
  operations: {
    description: 'insights.Operations',
    defaultMessage: 'Operations',
    id: 'FKRNeY',
  },
  customerEngagement: {
    description: 'insights.customerEngagement',
    defaultMessage: 'Customer Engagement',
    id: 'J0KQxl',
  },
  salesTrends: {
    description: 'insights.salesTrends',
    defaultMessage: 'Sales Trends',
    id: 'h2kWpY',
  },
  customerOverview: {
    description: 'insights.customerOverview',
    defaultMessage: 'Customer Overview',
    id: 'HzL0yC',
  },
  productHighlights: {
    description: 'insights.productHighlights',
    defaultMessage: 'Product Highlights',
    id: 'o+/AWP',
  },
  reports: {
    description: 'insights.reports',
    defaultMessage: 'Reports',
    id: 'xg6NHl',
  },
  looker: {
    description: 'insights.looker',
    defaultMessage: 'Looker',
    id: 'xWJChv',
  },
});

export const breadcrumbMessages = defineMessages({
  dataExports: {
    defaultMessage: 'Data Exports',
    id: 'kHFl8W',
    description: 'breadcrumb label for the data exports section',
  },
  orderDetail: {
    defaultMessage: 'Order Detail',
    id: 'LyZRjh',
    description: 'breadcrumb label for the order detail report',
  },
  countryComparison: {
    defaultMessage: 'Country Comparison',
    id: 'LbXPe+',
    description: 'breadcrumb label for the country comparison report',
  },
  buyerComments: {
    defaultMessage: 'Buyer Comments',
    id: 'nvQ5QZ',
    description: 'breadcrumb label for the buyer comments report',
  },
  itemDemandSummary: {
    defaultMessage: 'Item Demand Summary',
    id: 'VzOQy7',
    description: 'breadcrumb label for the item demand summary report',
  },
  productSales: {
    defaultMessage: 'Product Sales',
    id: 'FiXid3',
    description: 'breadcrumb label for the product sales report',
  },
  returnedProducts: {
    defaultMessage: 'Returned Products',
    id: 'IspFhy',
    description: 'breadcrumb label for the returned products report',
  },
  shipmentCountByUser: {
    defaultMessage: 'Shipment Count By User',
    id: 'h8c+aR',
    description: 'breadcrumb label for the shipment count by user report',
  },
  shippedItems: {
    defaultMessage: 'Shipped Items',
    id: 'FSk39c',
    description: 'breadcrumb label for the shipped items report',
  },
  shippingCost: {
    defaultMessage: 'Shipping Cost',
    id: 'mq/rvH',
    description: 'breadcrumb label for the shipping cost report',
  },
  shippingManifest: {
    defaultMessage: 'Shipping Manifest',
    id: 'kaE9vU',
    description: 'breadcrumb label for the shipping manifest report',
  },
  batchDetail: {
    defaultMessage: 'Batch Detail',
    id: 'iL4DJw',
    description: 'breadcrumb label for the batch detail report',
  },
  accountBalanceHistory: {
    defaultMessage: 'Account Balance History',
    id: 'btoI8q',
    description: 'breadcrumb label for the account balance history report',
  },
  inventoryLowStock: {
    defaultMessage: 'Inventory Low Stock Report',
    id: '6lhRPC',
    description: 'breadcrumb label for the inventory low stock report',
  },
  inventoryAudit: {
    defaultMessage: 'Inventory Audit Report',
    id: 'DzIT9h',
    description: 'breadcrumb label for the inventory audit report',
  },
  inventoryOutOfStock: {
    defaultMessage: 'Inventory Out Of Stock Shipments',
    id: 'KsFOgi',
    description: 'breadcrumb label for the inventory out of stock shipments report',
  },
  inventoryStatus: {
    defaultMessage: 'Inventory Status Report',
    id: 'wx2QwW',
    description: 'breadcrumb label for the inventory status report',
  },
  hotkeysReference: {
    defaultMessage: 'Hotkeys Reference Sheet',
    id: 't8nQ6o',
    description: 'breadcrumb label for the hotkeys reference sheet',
  },
  barcodeScanAction: {
    defaultMessage: 'Barcode Scan Action Report',
    id: 'NDmhEw',
    description: 'breadcrumb label for the barcode scan action report',
  },
  barcodeScanQuickReference: {
    defaultMessage: 'Barcode Scan Action Quick Reference Sheet',
    id: 'L7p/zI',
    description: 'breadcrumb label for the barcode scan quick reference sheet',
  },
  customers: {
    defaultMessage: 'Customers',
    id: 'dj9V0G',
    description: 'breadcrumb label for the customers report',
  },
  orders: {
    defaultMessage: 'Orders',
    id: '4wahWT',
    description: 'breadcrumb label for the orders report',
  },
  shippedOrders: {
    defaultMessage: 'Shipped Orders',
    id: 'EhP97P',
    description: 'breadcrumb label for the shipped orders report',
  },
  shippedItemsExtract: {
    defaultMessage: 'Shipped Items',
    id: '/JzwGX',
    description: 'breadcrumb label for the shipped items extract report',
  },
  productAliases: {
    defaultMessage: 'Product Aliases',
    id: 'nz23Bb',
    description: 'breadcrumb label for the product aliases report',
  },
  ordersByLot: {
    defaultMessage: 'Orders By Lot',
    id: 'x+DGbW',
    description: 'breadcrumb label for the orders by lot report',
  },
});
